import { SourceLink } from "components/SourceLink";
import { ImagePreviewButton, ImagePreviewModal } from "components/buttons/ImagePreviewButton";
import { IdNameDto } from "dtos/IdNameDto";

export const Stimulus = (props: { promptText?: string; imageUrl?: string }) => {
    const { imageUrl, promptText } = props;

    return (
        <div className="stimulus__body">
            <div className="vstack gap-3 text-center">
                <div className="text-secondary h5 text-break">{promptText}</div>

                <div className="text-center">
                    <img alt="" src={imageUrl} className="img-fluid" />
                </div>
            </div>
        </div>
    );
};

export const StimulusImage = (props: {
    imageUrl: string;
    prompt: string;
    disabled?: boolean;
    isImageHidden?: boolean;
    hideModal?: boolean;
}) => {
    const { imageUrl, disabled, isImageHidden, prompt, hideModal } = props;

    return (
        <div className="stimulus__body">
            <div className="vstack gap-3 text-center">
                <div className="text-secondary h5 text-break">{prompt}</div>

                <ImagePreviewButton imageUrl={imageUrl} disabled={disabled} isImageHidden={isImageHidden} />

                {!hideModal && <ImagePreviewModal imageUrl={imageUrl} isImageHidden={isImageHidden} />}
            </div>
        </div>
    );
};

export const StimulusSidebar = (props: {
    prompt: string;
    imageUrl: string;
    imageSource?: string;
    disabled?: boolean;
    isImageHidden?: boolean;
    hideModal?: boolean;
}) => {
    const { prompt, imageUrl, imageSource, disabled, isImageHidden, hideModal } = props;

    return (
        <div className="stimulus">
            <div className="stimulus__card shadow border border-dark">
                <StimulusImage
                    imageUrl={imageUrl}
                    disabled={disabled}
                    isImageHidden={isImageHidden}
                    prompt={prompt}
                    hideModal={hideModal}
                />
            </div>

            <SourceLink imageSource={imageSource} />
        </div>
    );
};

export const StimulusHorizontal = (props: {
    imageUrl: string;
    promptText: string;
    roundInstruction?: string;
    roundInstructions?: Array<IdNameDto>;
}) => {
    const { imageUrl, promptText, roundInstruction, roundInstructions } = props;

    return (
        <div className="bg-white border border-primary border-3">
            <div className="grid gap-0">
                <div
                    className="g-col-12 g-col-lg-4 align-self-center h-100 img-bg"
                    style={{
                        backgroundImage: `url('${imageUrl}')`,
                        minHeight: 100,
                    }}
                ></div>

                <div className="g-col-12 g-col-lg-8 align-self-center">
                    <div className="vstack text-center text-lg-start p-3 gap-2">
                        <div className="h6 text-secondary">{promptText}</div>

                        {roundInstruction && <div className="small text-body-secondary">{roundInstruction}</div>}

                        {!!roundInstructions?.length && (
                            <div className="vstack gap-2">
                                {roundInstructions.map(ri => (
                                    <div key={ri.id} className="vstack">
                                        <div className="h6 small">Round {ri.id}</div>
                                        <div className="small text-body-secondary">{ri.name}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="hstack gap-3"></div>
        </div>
    );
};
